import React from 'react';
import { CONSTANTS } from '../utils/constants';
import { CountdownTimer } from './CountdownTimer';
import { scrollToOffer } from '../utils/scroll';
import { ArrowRight, Crown } from 'lucide-react';
export const FinalCTASection: React.FC = () => {
  const handleBuyPremium = () => {
    window.open(CONSTANTS.PREMIUM_PAYMENT_LINK, '_blank');
  };
  return <section className="py-20 bg-blue-900 text-white relative overflow-hidden" data-id="element-68">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-69">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-white blur-3xl" data-id="element-70"></div>
        <div className="absolute bottom-0 right-0 w-full h-1/2 bg-gradient-to-t from-blue-950 to-transparent" data-id="element-71"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-72">
        <h2 className="text-4xl md:text-5xl font-black mb-6 leading-tight" data-id="element-73">
          ¿Listo para transformar tus clases de gimnasia artística?
        </h2>
        <p className="text-xl text-blue-200 mb-10 max-w-2xl mx-auto" data-id="element-74">
          No pierdas más tiempo planificando desde cero. Obtené el sistema
          completo hoy mismo y empezá a disfrutar de enseñar.
        </p>

        <div className="bg-blue-800/50 border border-blue-700 rounded-2xl p-6 md:p-8 max-w-2xl mx-auto backdrop-blur-sm mb-6" data-id="element-75">
          <div className="flex flex-col items-center justify-center space-y-4 mb-6" data-id="element-76">
            <span className="text-red-400 font-bold uppercase tracking-wider text-sm" data-id="element-77">
              La oferta termina en:
            </span>
            <CountdownTimer size="lg" theme="dark" data-id="element-78" />
          </div>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-79">
            <button onClick={handleBuyPremium} className="flex-1 bg-yellow-500 hover:bg-yellow-400 text-white font-black text-xl py-5 px-6 rounded-xl shadow-lg hover:shadow-yellow-500/30 transform hover:-translate-y-1 transition-all duration-200 flex flex-col items-center justify-center" data-id="element-80">
              <span className="flex items-center" data-id="element-81">
                <Crown className="mr-2 w-5 h-5" data-id="element-82" />
                PACK PREMIUM {CONSTANTS.PRICES.PREMIUM_SALE}
              </span>
              <span className="text-sm font-medium text-yellow-100 mt-1" data-id="element-83">
                Todo incluido + 3 ebooks exclusivos
              </span>
            </button>

            <button onClick={scrollToOffer} className="flex-1 bg-transparent border-2 border-blue-400 hover:bg-blue-800 text-white font-bold text-lg py-5 px-6 rounded-xl transition-all duration-200 flex flex-col items-center justify-center" data-id="element-84">
              <span className="flex items-center" data-id="element-85">
                PACK ESENCIAL {CONSTANTS.PRICES.SALE}
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-86" />
              </span>
              <span className="text-sm font-medium text-blue-300 mt-1" data-id="element-87">
                Ver todas las opciones
              </span>
            </button>
          </div>

          <p className="mt-4 text-sm text-blue-300" data-id="element-88">
            Pago único • Acceso de por vida • Garantía de 45 días
          </p>
        </div>
      </div>
    </section>;
};